import React, { useState } from 'react';
import { HStack, Text, IconButton, useClipboard, Tooltip } from '@chakra-ui/react';
import { FiCopy, FiCheck } from 'react-icons/fi';

interface Props {
  url: string;
  /** Show the scheme-less form for compactness. */
  compact?: boolean;
}

export const ShortUrlCopy: React.FC<Props> = ({ url, compact }) => {
  const { onCopy, hasCopied } = useClipboard(url);
  const [hover, setHover] = useState(false);
  const display = compact ? url.replace(/^https?:\/\//, '') : url;

  return (
    <HStack
      spacing={1}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      role="group"
    >
      <Text fontFamily="mono" fontSize="sm" color="var(--brand-primary)" fontWeight="medium">
        {display}
      </Text>
      <Tooltip label={hasCopied ? 'Copied!' : 'Copy short URL'} closeOnClick={false}>
        <IconButton
          aria-label="Copy short URL"
          icon={hasCopied ? <FiCheck /> : <FiCopy />}
          size="xs"
          variant="ghost"
          colorScheme={hasCopied ? 'green' : 'gray'}
          opacity={hover || hasCopied ? 1 : 0.35}
          onClick={(e) => {
            e.stopPropagation();
            onCopy();
          }}
        />
      </Tooltip>
    </HStack>
  );
};
